import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadTreatment } from '@surfline/web-common/dist/features/redux';
import { FUNNEL_PLAN_SELECTOR } from '../../common/utils/treatments';
import { fetchEntitlements } from '../../redux/actions/entitlements';
import { fetchPlans } from '../../redux/actions/plans';
import { fetchCards } from '../../redux/actions/cards';
import { trackEvent, navigatedToPage } from '../../redux/actions/segmentEvents';
import { toggleRegistrationForm } from '../../redux/actions/interactions';
import { getAccessToken } from '../../selectors/auth';
import { getPremiumStatus, getTrialEligibility } from '../../selectors/entitlements';
import { getSelectedPlanId, getPremiumPlans, getTrialPeriodDays } from '../../selectors/plans';
import { PaymentWrapper, RegistrationWrapper } from '../../containers';
import {
  RailCTA,
  MobileRailCTA,
  LeftRail,
  RightRail,
  PremiumSuccess,
  UpgradeHeader,
  RegistrationSubtitle,
  FunnelHelmet,
  FacebookLogin,
} from '../../components';
import en from '../../international/translations/en';
import { company } from '../../config';

class Upgrade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      registrationRendered: false,
      checkoutRendered: false,
      enableFunnelPlanTest: this.props.doLoadTreatment(FUNNEL_PLAN_SELECTOR) === 'on' && company === 'sl',
    };
    this.props.doNavigatedToPage('Funnel', 'Upgrade', {}, { Wootric: false });
  }

  componentDidMount() {
    const { doLoadTreatment } = this.props;
    /**
     * These treatements are temporary and used to
     * validate the Split/Segment metrics within this app.
     */
    doLoadTreatment('account_only_test');
    doLoadTreatment('cross_app_only_test');
  }

  viewedCheckout = () => {
    if (!this.state.checkoutRendered) {
      this.setState({ checkoutRendered: true });
      this.props.doTrackEvent('Viewed Checkout Step', { step: 2 });
    }
  }

  viewedRegistration = () => {
    if (!this.state.registrationRendered) {
      this.setState({ registrationRendered: true });
      this.props.doTrackEvent('Viewed Checkout Step', { step: 1 });
    }
  }

  registrationSuccess = async () => {
    const {
      doFetchEntitlements,
      doFetchPlans,
      doFetchCards,
    } = this.props;
    await doFetchEntitlements();
    await doFetchCards();
    await doFetchPlans();
  };

  renderRegistrationForm = () => {
    const {
      showLogin,
      doToggleForm,
    } = this.props;
    return (
      <RegistrationWrapper
        showLogin={showLogin}
        formLocation="upgrade"
        viewedRegistration={this.viewedRegistration}
        successCallback={this.registrationSuccess}
      >
        <FunnelHelmet showLogin={showLogin} />
        <UpgradeHeader hideSubtitle >
          <RegistrationSubtitle showLogin={showLogin} doToggleForm={doToggleForm} />
        </UpgradeHeader>
        <FacebookLogin
          formLocation="upgrade"
          successCallback={this.registrationSuccess}
        />
      </RegistrationWrapper>
    );
  }

  renderPaymentForm = () => {
    const {
      isPremium,
      trialEligible,
      trialPeriodDays,
      coupon,
      selectedPlanId,
    } = this.props;
    if (isPremium) return window.location.assign('/account/subscription');
    const { enableFunnelPlanTest, registrationRendered } = this.state;
    return (
      <PaymentWrapper
        formLocation="upgrade"
        viewedCheckout={this.viewedCheckout}
        enableFunnelPlanTest={enableFunnelPlanTest}
        shouldRedirectToOnboarding={registrationRendered}
      >
        <UpgradeHeader
          coupon={coupon}
          trialEligible={trialEligible}
          selectedPlanId={selectedPlanId}
          trialPeriodDays={trialPeriodDays}
        />
      </PaymentWrapper>
    );
  };

  render() {
    const {
      accessToken,
      plans,
      subscriptionSuccess,
    } = this.props;

    const ctaCopy = {
      ...en.rail_cta,
      ...en.premiumFeatures,
    };
    return (
      <div className="upgrade-funnel">
        <MobileRailCTA copy={ctaCopy} />
        <LeftRail>
          <div className="upgrade-funnel__content">
            {subscriptionSuccess ? (
              <PremiumSuccess />
            ) : (
              <div>
                {accessToken && plans ? (
                  this.renderPaymentForm()
                ) : (
                  this.renderRegistrationForm()
                )}
              </div>
            )}
          </div>
        </LeftRail>
        <RightRail>
          <RailCTA copy={ctaCopy} />
        </RightRail>
      </div>
    );
  }
}

export default connect(
  state => ({
    accessToken: getAccessToken(state),
    entitlements: state.entitlements,
    isPremium: getPremiumStatus(state),
    trialEligible: getTrialEligibility(state),
    trialPeriodDays: getTrialPeriodDays(state),
    plans: getPremiumPlans(state),
    subscriptionSuccess: state.subscription.success,
    showLogin: state.interactions.showLogin,
    coupon: state.coupon.coupon,
    selectedPlanId: getSelectedPlanId(state),
  }),
  dispatch => ({
    doToggleForm: showLogin => dispatch(toggleRegistrationForm(showLogin, 'funnel')),
    doFetchEntitlements: () => dispatch(fetchEntitlements()),
    doFetchPlans: () => dispatch(fetchPlans()),
    doTrackEvent: (name, properties) => dispatch(trackEvent(name, properties)),
    doNavigatedToPage: (name, category, properties, integrations) =>
      dispatch(navigatedToPage(name, category, properties, integrations)),
    doFetchCards: () => dispatch(fetchCards()),
    doLoadTreatment: treatment => dispatch(loadTreatment(treatment)),
  }),
)(Upgrade);
